// Custom, minimalist SVG icons for Rock / Paper / Scissors.
// Sized via `size` prop, colored via currentColor.

export function RockIcon({ size = 64, className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="Rock"
    >
      {/* Rugged asteroid rock */}
      <path d="M14 34 L10 22 L20 12 L34 8 L48 14 L56 24 L54 40 L44 52 L28 56 L14 50 L8 40 Z" />
      <path d="M20 30 L26 26" />
      <path d="M36 22 L42 26" />
      <path d="M42 38 L48 34" />
      <path d="M22 44 L30 42" />
      <circle cx="32" cy="34" r="1.6" fill="currentColor" />
      <circle cx="24" cy="22" r="1.2" fill="currentColor" />
      <circle cx="46" cy="30" r="1.2" fill="currentColor" />
    </svg>
  );
}

export function PaperIcon({ size = 64, className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="Paper"
    >
      {/* Folded parchment */}
      <path d="M14 8 H42 L54 20 V56 H14 Z" />
      <path d="M42 8 V20 H54" />
      <path d="M20 30 H44" />
      <path d="M20 38 H44" />
      <path d="M20 46 H36" />
    </svg>
  );
}

export function ScissorsIcon({ size = 64, className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="Scissors"
    >
      {/* Twin blades */}
      <circle cx="16" cy="46" r="8" />
      <circle cx="48" cy="46" r="8" />
      <path d="M22 40 L52 12" />
      <path d="M42 40 L12 12" />
      <path d="M32 34 L32 26" />
      <path d="M32 22 L32 18" />
    </svg>
  );
}

export function getRpsIcon(key) {
  if (key === "rock") return RockIcon;
  if (key === "paper") return PaperIcon;
  return ScissorsIcon;
}
